module.exports = __webpack_public_path__ + "img/site_type_img_16.16cbba2c.png";